$(document).ready( function () {

  $(function(){
    $('.annonces-carousel').flickity({
      // options
      cellAlign: 'left',
      contain: true,
      autoPlay: 5000
    });

    $('.book-carousel').flickity({
      // options
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      groupCells: true,
      pageDots: false
    });

    var navPopOpen = false;
    $('.link-more-popup').on('click', function(){
      if($('.bottom-nav-wrapper .nav-popup').hasClass('-hide')){
        $('.bottom-nav-wrapper .nav-popup').removeClass('-hide');
        navPopOpen = true;
      } else {
        $('.bottom-nav-wrapper .nav-popup').addClass('-hide');
        navPopOpen = false;
      }
    });

    var dossierPopOpen = false;
    $('.openDossierDropDown').on('click', function(e){
      e.preventDefault();

      if($('.dossiers-theme-popup').hasClass('-hide')){
        $('.dossiers-theme-popup').removeClass('-hide');
        dossierPopOpen = true;
      } else {
        $('.dossiers-theme-popup').addClass('-hide');
        dossierPopOpen = false;
      }
    });

    var searchBigWrapperOpen = false;
    $('.searchBigWrapperOpen').on('click', function(){
      if($('.search-big-wrapper').hasClass('-hide')){
        $('.search-big-wrapper').removeClass('-hide');
        $('body').addClass('-overflow-hidden');
        $('.search-big-wrapper').find('.search-big-input').focus();
        searchBigWrapperOpen = true;
      } else {
        $('.search-big-wrapper').addClass('-hide');
        $('body').removeClass('-overflow-hidden');
        searchBigWrapperOpen = false;
      }
    });

    $('.searchBigCloseBtn').on('click', function(event){
      event.preventDefault();
      $('.search-big-wrapper').addClass('-hide');
      $('body').removeClass('-overflow-hidden');
      searchBigWrapperOpen = false;
    });

    $('body').on('keydown', function(e){
      if (e.keyCode === 27) {
        $('.search-big-wrapper').addClass('-hide');
        $('body').removeClass('-overflow-hidden');
        searchBigWrapperOpen = false;

        $(".dossiers-theme-popup").addClass('-hide');
        dossierPopOpen = false;

        $('.bottom-nav-wrapper .nav-popup').addClass('-hide');
        navPopOpen = false;
      }
    });

    if($(".article-main-wrapper").length){
      var bottomOfOthDiv = $(".article-main-wrapper").offset().top + $(".article-main-wrapper").outerHeight();
      $(window).scroll(function() {
          if($(window).scrollTop() > bottomOfOthDiv) { //scrolled past the other div?
              $(".sumome-share-client-wrapper-left-page").addClass("hide"); //reached the desired point -- show div
          } else {
            $(".sumome-share-client-wrapper-left-page").removeClass("hide");
          }
      });
    }


    $(document).mouseup(function (e) {
      var container = $(".bottom-nav-wrapper .nav-popup");
      if(navPopOpen === true){
        if (!container.is(e.target) && container.has(e.target).length === 0 && !$('.link-more-popup').is(e.target))
        {
            container.addClass('-hide');
            navPopOpen = false;
        }
      }

      container = $(".dossiers-theme-popup");
      if(dossierPopOpen === true){
        if (!container.is(e.target) && container.has(e.target).length === 0 && !$('.dossiers-popup-btn').is(e.target))
        {
            container.addClass('-hide');
            dossierPopOpen = false;
        }
      }
    });

    $('.responsive-navigation .nav-popup-wrapper').hide();
    $('.open-responsive-nav').on('click', function(e){
      e.preventDefault();
      if($('.responsive-navigation .nav-popup-wrapper').hasClass('-hide')){
        $('.responsive-navigation .nav-popup-wrapper').slideDown(150).removeClass('-hide');
      } else {
        $('.responsive-navigation .nav-popup-wrapper').slideUp(150).addClass('-hide');
      }
    });


    // init Isotope
    var $grid = $('.themes-list-wrapper').isotope({
      itemSelector: '.element-item',
      layoutMode: 'fitRows',
      getSortData: {
        name: '.name',
        articleNbr: '.articleNbr parseInt'
      },
      sortAscending:{
        name: true,
        articleNbr : false
      },
      sortBy : 'articleNbr'
    });

    // bind sort button click
    $('.sort-themes-by-button-group').on( 'click', 'button', function() {
      var sortValue = $(this).attr('data-sort-value');
      $grid.isotope({ sortBy: sortValue });
    });

    // change is-checked class on buttons
    $('.sort-themes-by-button-group').each( function( i, buttonGroup ) {
      var $buttonGroup = $( buttonGroup );
      $buttonGroup.on( 'click', 'button', function() {
        $buttonGroup.find('.is-checked').removeClass('is-checked');
        $( this ).addClass('is-checked');
      });
    });

    // scroll btn
    $('body').append('<div class="scrollup"></div>');
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        $('.scrollup').fadeIn();
      } else {
        $('.scrollup').fadeOut();
      }
    });
    $('.scrollup').click(function () {
      $("html, body").animate({
        scrollTop: 0
      }, 600);
      return false;
    });


    $(function prepareList() {
      $('.expandable-list').find('li:has(ul)').unbind('click').click(function() {
        //if(this === event.target) {
          $(this).toggleClass('expanded');
          $(this).children('ul').toggle('fast');
        //}
        return false;
      }).addClass('collapsed').removeClass('expanded').children('ul').hide();
     
      //Hack to add links inside the cv
      $('.expandable-list a').unbind('click').click(function() {
        window.location.href = $(this).attr('href');
        return false;
      });

    });

    
    $('.js-agree-to-cookies').on('click',function(e){
      e.preventDefault();
      $('.cookies-bandeau').addClass("hide");
      localStorage.setItem('cookies', "accepted");
    });

    if(localStorage.getItem('cookies') !== "accepted"){
      $('.cookies-bandeau').removeClass("hide");
    }
  });


  // table des matières
  $(".article-content h1, .article-content h2, .article-content h3, .article-content h4").each(function(i) {
      var current = $(this);
      var html = current.html();
      current.attr("id", "title" + i);
      $(".table-content-content").append("<a id='link" + i + "' href='#title" +
          i + "' class='refering-"+current[0].localName+"'>" + 
          current[0].innerText + "</a>");
  });

  $(".table-content-btn-wrapper").clone().appendTo('.table-content-article-wrapper');

  $(".table-content-content a").click(function(e) {
    var scrollTo = $(this).attr('href');
    $('html,body').animate({
        scrollTop: $(scrollTo).offset().top-70},
       200);
  });

  $('.table-content-top-btn').on('click', function(e){
    e.preventDefault();
    $('.table-content-content').toggleClass('hide');
    $('.table-content-top-btn').toggleClass('-open');
  });

  setTimeout(function(){
    $('.sidebar-wrapper .table-content-btn-wrapper').width($('.table-content-wrapper').width());
  },100);

  $(window).bind('scroll', function() {
    $('.sidebar-wrapper .table-content-btn-wrapper').each(function() {
        var pin = $(this);
        var position = pin.position().top - $(window).scrollTop();
        //var bottom = pin.next().position().top + pin.next().height() - $(window).scrollTop();
        var inner = $('.sidebar-wrapper .table-content-wrapper').position().top - $(window).scrollTop();
        
        if (position <= 0 && inner <= 15) {
            pin.addClass('-pin');
            $('.sidebar-wrapper .table-content-wrapper').addClass('-pin');
        } 
        if (inner >= 15) {
            pin.removeClass('-pin');
            $('.sidebar-wrapper .table-content-wrapper').removeClass('-pin');
        }
    });        
  });

  var modules = {
    $window: $(window),
    $html: $('html'),
    $body: $('body'),
    $container: $('.container'),
    
    init: function () {
      $(function () {
         modules.modals.init();
      });
    }
    
    ,modals: {
      trigger: $('.modal-trigger'),
      modal: $('.modal'),
      scrollTopPosition: null,
    
      init: function () {
        var self = this;
    
        if (self.trigger.length > 0 && self.modal.length > 0) {
          modules.$body.append('<div class="modal-overlay"></div>');
    
          self.triggers();
        }
      },
    
      triggers: function () {
        var self = this;
      
        self.trigger.on('click', function (e) {
          e.preventDefault();
          var $trigger = $(this);
        
          self.openModal($trigger, $trigger.data('modalId'));
        });
      
        $('.modal-overlay').on('click', function (e) {
          e.preventDefault();
          self.closeModal();
        });
      
        modules.$body.on('keydown', function(e){
          if (e.keyCode === 27) {
            self.closeModal();
          }
        });
      
        $('.modal-close').on('click', function(e) {
          e.preventDefault();
          self.closeModal();
        });
      },
      
      openModal: function (_trigger, _modalId) {
        var self = this,
            scrollTopPosition = modules.$window.scrollTop(),
            $targetModal = $('#' + _modalId);
        
        self.scrollTopPosition = scrollTopPosition;
        
        modules.$html
        .addClass('modal-show')
        .attr('data-modal-effect', $targetModal.data('modal-effect'));
        
        $targetModal.addClass('modal-show');
        
        modules.$container.scrollTop(scrollTopPosition);
      },
        
      closeModal: function () {
        var self = this;
        
        $('.modal-show').removeClass('modal-show');
        modules.$html
          .removeClass('modal-show')
          .removeAttr('data-modal-effect');
          
        modules.$window.scrollTop(self.scrollTopPosition);
      }
    }
  }

  modules.init();

  // remove orphelin
  $('h1,h2,h3,p').each(function() {
    $(this).html($(this).html().replace(/\s([^\s<]{0,10})\s*$/,'&nbsp;$1'));
  });

  $('.pagination-dossiers-wrapper a').attr('href', function(_, href){
    return href+'#dossiers'
  });
  $('.pagination-actualites-wrapper a').attr('href', function(_, href){
    return href+'#actualites'
  });
  
  $('a.email-address').each(function(){
      $(this).attr("href", "mailto:"+$(this).data('email')+"@"+$(this).data('address')).html( $(this).data('email')+"@"+$(this).data('address') );
    });

    
  $('.bottom-nav-wrapper a.menu_item').hover(function(){
    console.log('hover in menu');
    var item_hover = $(this).data('item');
    $('.hero_banner').hide();
    // $('.hero_banner').fadeOut(150);
    $('#hero_banner_'+item_hover).css("display", "flex").hide().fadeIn(500);
  },function() {
    // console.log('hover out menu');
  });
});
